import { IRepeatableWidget } from '../../../widgets/repository/advanced/repeatable/IRepeatableWidget';
import { Datatype } from '../../datatype/Datatype';
import { IReference, ReferenceType } from '../IReference';
import { IReferencePath } from '../IReferencePath';
import { resolveChildrenReferences } from '../resolve/resolveTreeReferences';

export function getArrayWidgetReference(
  path: IReferencePath,
  widget: IRepeatableWidget,
): IReference {
  return {
    type: ReferenceType.Widget,
    widgetType: widget.type,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      type: Datatype.Array,
      itemsType: Datatype.Object,
      // TODO Qui forse `path` dovrebbe essere reimpostato a `[]` in quanto stiamo
      // ragionando su un percorso "relativo" al singolo elemento della lista?
      structure: resolveChildrenReferences(path, widget),
    },
  };
}
